import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.333 11.665h.217c1.615-.01 2.615-1.073 2.615-2.694V3.59c0-1.63-1.008-2.696-2.637-2.696l-4.5.002C4.892.903 4.06 1.43 3.667 2.309"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m7.948 2.334-4.5.002C1.835 2.346.834 3.408.834 5.029v5.382c0 1.629 1.008 2.696 2.637 2.696l4.5-.002c1.615-.01 2.616-1.073 2.616-2.694V5.029c0-1.629-1.009-2.695-2.638-2.695",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.169 10.218H3.61M7.169 7.768H3.61M5.223 5.324H3.61"
    }, null, -1)
  ]))]))
}
export default { render: render }